import { createComponent } from '@carvana/vdp-components';
import styled from 'styled-components';
import MagnifyIcon from '~/icons/Magnify';

// Main keyword search component that's brought into header component
export const KeywordSearchWrapper = styled.div.attrs({
  className:
    'absolute grid items-center bg-white border-grey-2 border border-solid rounded l:!w-full'
})`
  width: ${props => (props.inputFocus ? '100%' : props.width)};
  transition: width 300ms linear;
  grid-template-columns: 1fr auto auto;

  max-width: ${props =>
    props.isStickySearchbar && !props.inputFocus ? '650px' : undefined};

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    max-width: ${props => (props.isStickySearchbar ? '400px' : undefined)};
  }

  @media (min-width: ${props => props.theme.breakpoints.values.lg}px) {
    max-width: ${props => (props.isStickySearchbar ? '650px' : undefined)};
  }
  @media (min-width: ${props => props.theme.breakpoints.values.xl}px) {
    max-width: ${props => (props.isStickySearchbar ? '912px' : undefined)};
  }
`;

// Main search bar wrapper
export const stickyBarHeightMobile = 40;
export const stickyBarHeightDesktop = 46;
export const barHeightMobile = 45;
export const barHeightDesktop = 55;
export const SearchBarContainer = styled.div.attrs({
  className:
    'grid justify-items-start items-center relative m-0 max-w-full bg-grey-1 hover:bg-white focus:bg-white'
})`
  grid-template-columns: 32px 1fr auto;
  height: ${props =>
    props.isStickySearchbar ? stickyBarHeightMobile : barHeightMobile}px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    grid-template-columns: 35px 1fr auto;
    height: ${props =>
      props.isStickySearchbar ? stickyBarHeightDesktop : barHeightDesktop}px;
  }
`;

// Search bar magnifying glass icon

export const SearchIcon = styled(MagnifyIcon).attrs({
  className: 'w-16 h-16 -translate-x-[3px] m:w-18 m:h-18 m:translate-x-0'
})`
  path {
    fill: var(--cvna-color-blue-6);
  }

  &.grey-fill {
    path {
      fill: var(--cvna-color-grey-5);
    }
  }
`;

export const SearchIconWrapper = createComponent('div', {
  className: 'w-full h-full flex items-center justify-end'
});

export const StickyHeaderText = createComponent('p', {
  className: 'm-0 text-[14px] font-bold text-white uppercase pr-16 l:pr-0',
  'data-qa': 'sticky-header-text'
});
